/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Export_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Speaker metrics exported" |
*
* @param {Speakers_Metrics_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_export_complete_toast = /** @type {((inputs?: Speakers_Metrics_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Speaker metrics exported")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speaker metrics exported")
	if (locale === "it") return /** @type {LocalizedString} */ ("Speaker metrics exported")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Speaker metrics exported")
	if (locale === "es") return /** @type {LocalizedString} */ ("Speaker metrics exported")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Speaker metrics exported")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Speaker metrics exported")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Speaker metrics exported")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Speaker metrics exported")
	return /** @type {LocalizedString} */ ("Speaker metrics exported")
});